import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import styles from "./TaxDeductionWidget.module.scss";
import { TaxDeductionBarChart } from "./TaxDeductionBarChart";
import { EffektButton, EffektButtonVariant } from "../../../shared/components/EffektButton/EffektButton";
import { EffektTextInput } from "../../../shared/components/EffektTextInput/EffektTextInput";
import { WidgetContext } from "../../layout/layout";
import { HorizontalTaxDeductionBarChart } from "./TaxDeductionBarChartHorizontal";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import { usePlausible } from "next-plausible";
import { thousandize } from "../../../../util/formatting";
export const TaxDeductionWidget: React.FC<{
  title: string;
  description: string;
  suggestedSums: number[];
  minimumTreshold: number;
  maximumTreshold: number;
  percentageReduction: number;
  donationsLabel?: string;
  taxDeductionReturnDescriptionTemplate?: string;
  belowMinimumTresholdDescriptionTemplate?: string;
  buttonText?: string;
  chartLabels?: {
    maximumThresholdLabel?: string;
    minimumThresholdLabel?: string;
    currentValueLabel?: string;
    taxBenefitLabel?: string;
  };
  locale: string;
}> = t0 => {
  const $ = _c(67);
  const {
    title,
    description,
    suggestedSums,
    minimumTreshold,
    maximumTreshold,
    percentageReduction,
    donationsLabel,
    taxDeductionReturnDescriptionTemplate,
    belowMinimumTresholdDescriptionTemplate,
    buttonText,
    chartLabels,
    locale
  } = t0;
  const plausible = usePlausible();
  let t1;
  if ($[0] !== locale || $[1] !== suggestedSums) {
    t1 = () => formatAmountInput(suggestedSums.slice(-2)[0].toString(), locale);
    $[0] = locale;
    $[1] = suggestedSums;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [sum, setSum] = React.useState(t1);
  const lastValidSum = parseAmountInput(sum);
  const [widgetContext, setWidgetContext] = useContext(WidgetContext);
  const isMobile = useIsMobile();
  const taxBenefit = lastValidSum >= minimumTreshold ? Math.min(lastValidSum, maximumTreshold) * percentageReduction : 0;
  const taxDeduction = Math.min(lastValidSum, maximumTreshold);
  const t2 = styles;
  const t3 = styles;
  const t4 = !isMobile && <TaxDeductionBarChart maximumThreshold={maximumTreshold} minimumThreshold={minimumTreshold} value={lastValidSum} taxBenefit={taxBenefit} labels={chartLabels} locale={locale} />;
  let t5;
  if ($[3] !== t4) {
    t5 = <div className={styles.desktopChart}>{t4}</div>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = styles;
  let t7;
  if ($[5] !== title) {
    t7 = <h5>{title}</h5>;
    $[5] = title;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== description) {
    t8 = <p>{description}</p>;
    $[7] = description;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = isMobile && <HorizontalTaxDeductionBarChart maximumThreshold={maximumTreshold} minimumThreshold={minimumTreshold} value={lastValidSum} taxBenefit={taxBenefit} labels={chartLabels} locale={locale} />;
  let t10;
  if ($[9] !== t9) {
    t10 = <div className={styles.mobileChart}>{t9}</div>;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== lastValidSum || $[12] !== locale || $[13] !== plausible || $[14] !== suggestedSums) {
    let t12;
    if ($[16] !== lastValidSum || $[17] !== locale || $[18] !== plausible) {
      t12 = suggestedSum => {
        const formattedSuggestedSum = thousandize(suggestedSum, locale);
        return <EffektButton key={suggestedSum} onClick={() => {
          plausible("TaxWidgetSelectSuggestedSum", {
            props: {
              page: window.location.pathname,
              sum: suggestedSum
            }
          });
          setSum(formattedSuggestedSum);
        }} variant={EffektButtonVariant.SECONDARY} selected={lastValidSum === suggestedSum} style={{
          fontSize: "0.9rem"
        }} squared={true}>{formattedSuggestedSum} kr</EffektButton>;
      };
      $[16] = lastValidSum;
      $[17] = locale;
      $[18] = plausible;
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    t11 = suggestedSums.map(t12);
    $[11] = lastValidSum;
    $[12] = locale;
    $[13] = plausible;
    $[14] = suggestedSums;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[20] !== t11) {
    t12 = <div className={styles.suggestedSums}>{t11}</div>;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = donationsLabel ?? "Donasjoner";
  let t14;
  if ($[22] !== t13) {
    t14 = <label htmlFor="">{t13}:</label>;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== sum) {
    t15 = sum.toString();
    $[24] = sum;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== locale) {
    t16 = val => {
      setSum(formatAmountInput(val, locale));
    };
    $[26] = locale;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t15 || $[29] !== t16) {
    t17 = <EffektTextInput value={t15} name="taxDeductionSumInput" type="tel" placeholder="0" onChange={t16} denomination="kr" variant="underlined" />;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t14 || $[32] !== t17) {
    t18 = <div className={styles.input}>{t14}{t17}</div>;
    $[31] = t14;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t12 || $[35] !== t18) {
    t19 = <div className={styles.selectSum}>{t12}{t18}</div>;
    $[34] = t12;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== locale || $[38] !== taxBenefit || $[39] !== taxDeduction || $[40] !== taxDeductionReturnDescriptionTemplate) {
    t20 = taxBenefit > 0 && <p>{taxDeductionReturnDescriptionTemplate ? taxDeductionReturnDescriptionTemplate.replace("{taxDeduction}", thousandize(taxDeduction, locale)).replace("{taxBenefit}", thousandize(taxBenefit, locale)) : `Med ${Intl.NumberFormat("no-NB").format(taxDeduction)} kr i skattefradrag i år får du tilbake ${Intl.NumberFormat("no-NB").format(taxBenefit)} kroner på skatten.`}</p>;
    $[37] = locale;
    $[38] = taxBenefit;
    $[39] = taxDeduction;
    $[40] = taxDeductionReturnDescriptionTemplate;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  const t21 = taxBenefit === 0 && <p>{belowMinimumTresholdDescriptionTemplate ? belowMinimumTresholdDescriptionTemplate.replace("{lastValidSum}", thousandize(lastValidSum, locale)).replace("{minimumTreshold}", thousandize(minimumTreshold, locale)) : `Med ${Intl.NumberFormat("no-NB").format(lastValidSum)} kr i donasjoner er du under minstegrensen på ${Intl.NumberFormat("no-NB").format(minimumTreshold)} kr for å få skattefradrag.`}</p>;
  let t22;
  if ($[42] !== lastValidSum || $[43] !== plausible || $[44] !== setWidgetContext || $[45] !== widgetContext) {
    t22 = () => {
      plausible("OpenDonationWidget", {
        props: {
          page: window.location.pathname
        }
      });
      plausible("OpenDonationWidgetTaxWidgetCTA", {
        props: {
          page: window.location.pathname,
          sum: lastValidSum
        }
      });
      setWidgetContext({
        ...widgetContext,
        open: true,
        prefilledSum: lastValidSum,
        prefilledRecurring: null
      });
    };
    $[42] = lastValidSum;
    $[43] = plausible;
    $[44] = setWidgetContext;
    $[45] = widgetContext;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      padding: "0.75rem 3rem"
    };
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  const t24 = buttonText ?? "F\xE5 skattefradrag";
  let t25;
  if ($[48] !== t22 || $[49] !== t24) {
    t25 = <div className={styles.cta}><EffektButton onClick={t22} variant={EffektButtonVariant.PRIMARY} style={t23}>{t24}</EffektButton></div>;
    $[48] = t22;
    $[49] = t24;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t10 || $[52] !== t19 || $[53] !== t20 || $[54] !== t21 || $[55] !== t25 || $[56] !== t6.description || $[57] !== t7 || $[58] !== t8) {
    t26 = <div className={t6.description}>{t7}{t8}{t10}{t19}{t20}{t21}{t25}</div>;
    $[51] = t10;
    $[52] = t19;
    $[53] = t20;
    $[54] = t21;
    $[55] = t25;
    $[56] = t6.description;
    $[57] = t7;
    $[58] = t8;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t26 || $[61] !== t3.container || $[62] !== t5) {
    t27 = <div className={t3.container}>{t5}{t26}</div>;
    $[60] = t26;
    $[61] = t3.container;
    $[62] = t5;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== t2.wrapper || $[65] !== t27) {
    t28 = <div className={t2.wrapper}>{t27}</div>;
    $[64] = t2.wrapper;
    $[65] = t27;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  return t28;
};

/** The amount typed into an input, ignoring the thousand separators. An empty input is 0. */
const parseAmountInput = (value: string): number => Number(value.replace(/\D/g, ""));

/** Formats what the user typed with thousand separators, keeping an empty input empty. */
const formatAmountInput = (value: string, locale: string): string => value === "" ? "" : thousandize(parseAmountInput(value), locale);